import React from 'react';
import AgentOrb from '../primitives/AgentOrb';
import AgentStatusBar from './AgentStatusBar';
import PhaseActivity, { hasPhaseActivity } from './PhaseActivity';
import './chat.css';

const AgentMessage = ({
  children,
  continued = false,
  thinking,
  phase,
  phaseId,
  stepHistory,
  agentStopped,
  onStop,
  onResume,
}) => (
  <div className={`q-fade-in q-agent${thinking ? ' q-agent--thinking' : ''}`}>
    {/* Consecutive agent messages keep the column but show the orb once. */}
    <div className={`q-agent__mark${continued && !thinking ? ' q-agent__mark--hidden' : ''}`}>
      <AgentOrb thinking={!!thinking && !agentStopped} />
    </div>
    <div className="q-agent-content" style={{ flex: 1, minWidth: 0 }}>
      {thinking ? (
        <div>
          {(phase || agentStopped || (stepHistory && stepHistory.length > 0)) && (
            <AgentStatusBar
              phase={phase}
              stepHistory={stepHistory || []}
              agentStopped={agentStopped}
              onStop={onStop}
              onResume={onResume}
            />
          )}
          {!agentStopped && (
            hasPhaseActivity(phaseId) ? (
              <PhaseActivity phaseId={phaseId} />
            ) : (
              <div className="q-thinking" role="status">
                <span className="q-shimmer">Thinking</span>
              </div>
            )
          )}
        </div>
      ) : children}
    </div>
  </div>
);

export default AgentMessage;
